// extracted by mini-css-extract-plugin
export default {"layout":"a6Ptha","layoutContent":"b6Ptha"};